import {Component, OnInit} from '@angular/core';
import {Information} from '../../model/information';
import {InformationsService} from '../../services/informations.service';
import {UserService} from '../../services/user.service';
import {UserRequest} from '../../model/UserRequest';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {InfoTypePipe} from "../../components/common/InfoTypePipe";
import {InfoBlockComponent} from "../../components/common/info-block/info-block.component";
import {RouterLink} from "@angular/router";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";


@Component({
    selector: 'app-admin-index',
    templateUrl: './admin-index.component.html',
    imports: [
    FaIconComponent,
    InfoTypePipe,
    InfoBlockComponent,
    RouterLink,
    NgbTooltip
],
    styleUrls: ['./admin-index.component.css']
})
export class AdminIndexComponent implements OnInit {
  infos: Information[] = [];
  unhandledRequests: UserRequest[];

  constructor(private infosService: InformationsService, private userRequestService: UserService) {
  }

  ngOnInit(): void {
    this.infosService.getObjects().subscribe(data => {
      this.infos.length = 0;
      this.infos = this.infos.concat(data);
    });
    this.userRequestService.listRequests().subscribe(value => {
      this.unhandledRequests = value.filter(c => c.handledBy === null);
    });
  }
}
